import clsx from 'clsx';

import {extractErrorMessage} from '../../functions/extractErrorMessage';
import {AppError} from '../../utils/errors';
import {Icon} from '../Icon/Icon';

import {ERROR_KIND_CONFIG} from './errorKindConfig';

import type {AppErrorKind} from '../../utils/errors';

type Props = {
  error: unknown;
  kind?: AppErrorKind;
  className?: string;
};

export function FormLevelError(props: Props): React.JSX.Element | null {
  if (!props.error) return null;

  const kind = props.kind ?? (props.error instanceof AppError ? props.error.kind : 'critical');
  const {icon, iconClassName, textClassName} = ERROR_KIND_CONFIG[kind];

  return (
    <p className={clsx('text-sm font-medium', textClassName, props.className)}>
      <Icon icon={icon} className={clsx('mr-1', iconClassName)} />
      {extractErrorMessage(props.error)}
    </p>
  );
}

FormLevelError.displayName = 'FormLevelError';
